import { useCallback, useEffect } from 'react';
import useIsMobileView from './useIsMobileView';
import { debounce } from 'lodash';

const referenceSize = 16;

const adjustFontSize = (ref: React.RefObject<HTMLDivElement> | undefined, baseSize: number, isMobile: boolean) => {
  let width = window.innerWidth;
  let height = window.innerHeight;
  let calculatedSize = (width / 100) * (baseSize / referenceSize);

  if (ref?.current) {
    const element = ref.current;
    width = element.offsetWidth;
    height = element.offsetHeight;
    if (!isMobile) {
      calculatedSize = (width / 65) * (baseSize / referenceSize);
    } else {
      calculatedSize = (height / 80) * (baseSize / referenceSize);
    }
  }
  const currentFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
  const LIMIT_THRESHOLD = 0.02;

  if (calculatedSize !== currentFontSize && Math.abs(calculatedSize - currentFontSize) > LIMIT_THRESHOLD) {
    console.log('calculatedSize', calculatedSize);
    document.documentElement.style.fontSize = `${calculatedSize}px`;
  }
};

export const useRootFontSize = (ref?: React.RefObject<HTMLDivElement>, baseSize = 16) => {
  const isMobile = useIsMobileView({ checkForUserAgent: true });

  const debouncedAdjustFontSize = useCallback(
    debounce(() => adjustFontSize(ref, baseSize, isMobile), 100),
    [ref, baseSize, isMobile],
  );

  useEffect(() => {
    adjustFontSize(ref, baseSize, isMobile); // Initial adjustment

    if (ref?.current) {
      const resizeObserver = new ResizeObserver(debouncedAdjustFontSize);
      resizeObserver.observe(ref.current);

      return () => {
        resizeObserver.disconnect();
      };
    }

    const handleWindowResize = () => {
      debouncedAdjustFontSize();
    };

    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, [ref, baseSize, isMobile, debouncedAdjustFontSize]);
};
